import React, { Component } from 'react';
import { Table } from 'antd';
import { connect } from 'react-redux'
import { getTeachers } from '../../actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import { showModalPayment } from '../../../../redux/actions';
import UserInfo from './UserInfo';

class DataUsers extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  componentDidMount = () => {
    try {
      this.props.getTeachers();
    } catch (error) {
      
    }
  };
  

  render() {

    const { teachers, showModalPayment } = this.props;
    const {formatMessage} = this.context;

    const columns = [
      { title: '', width: 30, dataIndex: 'status', key: 'status', render: (status, record, index) => {
        return <div style={{width: 10, height: 10, borderRadius: '50%', background: status == 10 ? '#67d46c' : '#d46767'}} />
      } },
      { title: formatMessage('userNameCode'), dataIndex: 'username', key: 'username' },
      { title: formatMessage('firstNameCode'), dataIndex: 'firstname', key: 'firstname' },
      { title: formatMessage('lastNameCode'), dataIndex: 'lastname', key: 'lastname' },
      { title: formatMessage('emailCode'), dataIndex: 'email', key: 'email' },
      { title: formatMessage('registrationDateCode'), dataIndex: 'created_at', key: 'created_at', render: (text, record) => {
        return moment(text * 1000).format('MMMM DD, YYYY');
      }},
      { title: formatMessage('validUntilCode'), dataIndex: 'payment_date_active', key: 'payment_date_active', render: (value, user) => {
        return user.payment_date_active && user.payment_date_active > 0 ? moment.unix(user.payment_date_active).format('MMMM DD, YYYY') : '-'
      } },
      { title: formatMessage('subscrCode'), dataIndex: 'subscribtion', key: 'subscribtion', render: (value, user) => {
        return <button type="button" onClick={() => showModalPayment(true, user.id)} className="btn btn-success btn-sm">{formatMessage('paidSubCode')}</button>
      } },
    ];
  
    return (
      <Table
        columns={columns}
        expandedRowRender={teacher => <UserInfo teacher={teacher}  />}
        dataSource={teachers}
        // scroll={{ y: 1230 }}
      />
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  teachers: state.teacher.list,
})

const mapDispatchToProps = {
  getTeachers, 
  showModalPayment
}

export default connect(mapStateToProps, mapDispatchToProps)(DataUsers)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/UserOrganisation/components/DataUsers/DataUsers.jsx